// Minimal mdast transform: tag GitHub-style alert blockquotes as callouts.
// No external visitor dep — recurse over children ourselves. No raw HTML.
type MdastNode = { type: string; value?: string; children?: MdastNode[]; data?: Record<string, unknown> };

const MARKER = /^\[!(NOTE|TIP|IMPORTANT|WARNING|INSIGHT)\]\s*\n?/;

export function remarkCallouts() {
  return (tree: MdastNode) => walk(tree);
}

function walk(node: MdastNode) {
  if (node.type === 'blockquote') tagCallout(node);
  node.children?.forEach(walk);
}

function tagCallout(node: MdastNode) {
  const firstPara = node.children?.[0];
  if (firstPara?.type !== 'paragraph') return;
  const firstText = firstPara.children?.[0];
  if (firstText?.type !== 'text' || !firstText.value) return;
  const m = firstText.value.match(MARKER);
  if (!m) return;
  const type = m[1].toLowerCase();
  firstText.value = firstText.value.slice(m[0].length);
  if (firstText.value === '' && firstPara.children?.length === 1) {
    node.children?.shift(); // marker was alone on the line — drop the empty paragraph
  }
  node.data = {
    ...node.data,
    hProperties: {
      className: ['callout', `callout-${type}`],
      'data-callout': type,
    },
  };
}
